import * as React from 'react';
import { status_text } from '../exception-management/constants';
interface IProps {
    firstValue?: any,
    firstValueLabel?: string
    secondValue?: string,
    secondValueLabel?: string,
    thirdValue?: string,
    thirdValueLabel?: string,
    forthValue?: string,
    forthValueLabel?: string,
    fifthValue?: string,
    fifthValueLabel?: string,
    statusColor?: string,
    target?: number
}
export const HeaderStatusBar = (props: IProps) => {
    const hasError = (target: number) => props.target === target ? <span dangerouslySetInnerHTML={{ __html: status_text.negative }} /> : ''
    const getLine = (code: number): string => ''
    return (
        <div className="grid-wrapper padding-left-large">
            {props.firstValue && <div className={`col-25`} id="firstValue">
                <label className="section-header-label block" id="firstValue-label">{props.firstValueLabel ? props.firstValueLabel : 'Status'}</label>
                <label id="firstValue-value">{props.statusColor && hasError(0)} {props.firstValue} {getLine(0)}</label>
            </div>}
            {props.secondValue && <div className={`col-25`} id="secondValue">
                <label className="section-header-label block" id="secondValue-label">{props.secondValueLabel ? props.secondValueLabel : 'FinOps Status'}</label>
                <label id="secondValue-value">{props.statusColor && hasError(1)} {props.secondValue} {getLine(1)}</label>
            </div>}
            {props.thirdValue && props.thirdValueLabel && <div className={`col-25`} id="thirdValueTerms">
                <label className="section-header-label block" id="thirdValueTerms-label">{props.thirdValueLabel ? props.thirdValueLabel : 'Inco Terms'}</label>
                <label id="thirdValueTerms-value">{props.statusColor && hasError(2)} {props.thirdValue} {getLine(2)}</label>
            </div>}
            {props.forthValue && <div className={`col-25`} id="updateTime">
                <label className="section-header-label block" id="updateTime-label">{props.forthValueLabel ? props.forthValueLabel : 'Last Updated Time'}</label>
                <label id="updateTime-value">{props.statusColor && hasError(3)} {props.forthValue} {getLine(3)}</label>
            </div>}
            {props.fifthValue && props.fifthValue.length > 0 && <div className={`col-25`} id="fifthValue">
                <label className="section-header-label block" id="isDeleted-label">{props.fifthValueLabel ? props.fifthValueLabel : 'Prepaid/Collect'}</label>
                <label id="isDeleted-value">{props.statusColor && hasError(4)} {props.fifthValue} {getLine(4)}</label>
            </div>}
        </div>
    )
}